import Vue from 'vue'
import Pagination from './Pagination'
import { IMaskComponent } from 'vue-imask'
import DadataSuggestions from 'vue-dadata-suggestions'
import './documents/driver'
import './cars'
import './drivers'
import './common'
import './contracts/rent'
import './documents/car'
import './maps'
import './serve'
import './equipments'
import './companies'
import './users'
import './devices'
import TextHighlight from 'vue-text-highlight'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'

Vue.component('text-highlight', TextHighlight)
Vue.use(DadataSuggestions, { token: process.env.VUE_APP_DADATA_AUTH_TOKEN })
Vue.component('imask-input', IMaskComponent)

Vue.component('v-marker-cluster', Vue2LeafletMarkerCluster)

Vue.component('Pagination', Pagination)
